var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{staticClass:"loader fa fa-fw fa-spin fa-circle-o-notch",style:(_vm.style)})
}
var staticRenderFns = []

export { render, staticRenderFns }